import { Controller } from "@hotwired/stimulus"

const PRINT_COOLDOWN_MS = 3000

// Connects to data-controller="buscar-reportes"
export default class extends Controller {
  static targets = ["desde", "hasta", "obraSocial", "hoja", "count", "selectedList"]
  static values = {
    url: String,
    registro: Number,
    processingReport: Boolean,
    typesCount: Number
  }

  connect() {
    this.processingReportValue = Boolean(this.data.get("processingReport"));
    this.updateHojaSummary();

    this.element.addEventListener('change', (e) => {
      if (e.target.name === 'hoja[]' || e.target.id === 'select_all_hojas') {
        this.updateHojaSummary();
      }
    });
  }

  updateHojaSummary() {
    const hojas = (this.hojaTargets || []).filter(cb => cb.checked).map(cb => cb.value)
    const count = hojas.length

    if (this.hasCountTarget) this.countTarget.textContent = count

    if (this.hasSelectedListTarget) {
      if (count === 0) this.selectedListTarget.textContent = 'Todas'
      else {
        const max = 5
        const shown = hojas.slice(0, max).join(', ')
        this.selectedListTarget.textContent = hojas.length > max ? `${shown}, ...` : shown
      }
    }
  }

  imprimir(event) {
    event.preventDefault()
    if (this.submitting) return

    const trigger = event.currentTarget
    this.submitting = true
    trigger.classList.add('disabled')

    const desde = this.desdeTarget?.value
    const hasta = this.hastaTarget?.value
    const hojas = (this.hojaTargets || []).filter(cb => cb.checked).map(cb => cb.value)

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("registro", this.registroValue)

    if (hojas.length > 0) {
      hojas.forEach(h => url.searchParams.append("hoja[]", h))

      if (this.hasTypesCountValue && hojas.length === this.typesCountValue) {
        url.searchParams.set('include_archivos', '1')
      }
    }
    if (desde && desde.trim() !== "") {
      url.searchParams.set("start_date", desde)
    }
    if (hasta && hasta.trim() !== "") {
      url.searchParams.set("end_date", hasta)
    }

    if (url.pathname === "/" || url.pathname === "") {
      console.warn("buscar-reportes: URL appears empty or points to origin; check data-buscar-reportes-url-value")
    }

    window.open(url.toString(), "_blank")
    this.armCooldown(trigger)
  }

  imprimirLote(e) {
    e.preventDefault()
    if (this.submitting) return

    const trigger = e.currentTarget
    this.submitting = true
    trigger.classList.add('disabled')

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("start_date", this.desdeTarget.value)
    url.searchParams.set("end_date", this.hastaTarget.value)
    url.searchParams.set("obra_social", this.obraSocialTarget.value)

    window.open(url.toString(), "_blank")
    this.armCooldown(trigger)
  }

  armCooldown(trigger) {
    setTimeout(() => {
      this.submitting = false
      trigger.classList.remove('disabled')
    }, PRINT_COOLDOWN_MS)
  }
}
